import GroupSVG from "@design-system/ui-icons/vanilla/Group"
import { createIcon } from "../createIcon"

export const GroupIcon = createIcon(GroupSVG)
